export default __webpack_public_path__ + "static/media/4b5e46a157819e4c.5ab1e90d4a2d941cbd94efb03b82a120.svg";